import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  featuresList: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    marginTop: '24px'
  },
  feature: {
    backgroundColor: palette.shades[100],
    padding: '24px 32px',
    display: 'flex',
    alignItems: 'flex-start',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  featureIcon: {
    marginRight: '24px',
    padding: '12px',
    background: palette.brandGradients.main,
    borderRadius: '2px',
    boxShadow: palette.shadows.light,
    '& path': {
      fill: palette.shades[100]
    }
  },
  featuresLink: {
    padding: '24px 0',
    borderTop: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer'
    },
    '& .MuiSvgIcon-root': {
      marginRight: '5px',
      '& path': {
        fill: palette.shades[600]
      }
    }
  }
}));
export default useStyles;